import React, { Component, Fragment } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class StaticFilter extends Component {
  render() {
    return(
      <Fragment>
        {
          this.props.facets
          &&
          <h3 className="single-facet-title">{this.props.displayName}</h3>
        }
        <div className="facet-links">
        {
          this.props.facets
          &&
          this.props.values.map(fk => {
            const isSelected = this.props.isFacetActive(this.props.field, fk)
            return (
            <div key={fk} className={`facet-link-single ${isSelected && 'active'}`}>
              <a onClick={
                isSelected 
                ? 
                this.props.delFacet(this.props.field, fk)
                : 
                this.props.addFacet(this.props.field, fk)
              }>
              { fk }
              &nbsp;
              {
                this.props.facets[fk] &&
                `(${this.props.facets[fk]})`
              }
              &nbsp;
              { isSelected && <FontAwesomeIcon icon="times" color='#b41f28' /> }
              </a>
            </div>
          )})
        }
        </div>
      </Fragment>
    )
  }
}

export default StaticFilter